export type DocumentType = 'resume' | 'cover_letter';
export type SeniorityLevel = 'junior' | 'mid' | 'senior';
export type PostGenerationAction = 'open_editor' | 'download_immediately';

export interface ContentRules {
    highlight_impact: boolean;
    avoid_fictional_content: boolean;
}

export interface StructureRules {
    one_page_enforced?: boolean; // Resume only
    preserve_section_order: boolean;
}

export interface ExperienceAlignment {
    target_level: SeniorityLevel;
}

export interface SafetyRules {
    no_new_skills: boolean;
    no_new_roles: boolean;
    no_new_companies?: boolean; // Resume only
}

export interface OutputFlow {
    post_generation_action: PostGenerationAction;
}

export interface GenerationRules {
    document_type: DocumentType;
    content_rules: ContentRules;
    structure_rules: StructureRules;
    experience_alignment: ExperienceAlignment;
    safety_rules: SafetyRules;
    output_flow: OutputFlow;
}

// Default Configuration Constants
export const DEFAULT_GENERATION_RULES: GenerationRules = {
    document_type: 'resume',
    content_rules: {
        highlight_impact: true,
        avoid_fictional_content: true,
    },
    structure_rules: {
        one_page_enforced: true,
        preserve_section_order: true,
    },
    experience_alignment: {
        target_level: 'junior',
    },
    safety_rules: {
        no_new_skills: true,
        no_new_roles: true,
        no_new_companies: true,
    },
    output_flow: {
        post_generation_action: 'open_editor',
    },
};
